/** Sets the tab title; dev servers in a worktree prefix it with that worktree's name (empty in the main checkout and in builds). */
export function setPageTitle(text: string) {
  document.title = `${import.meta.env.NIMBLEZ_TITLE_PREFIX ?? ''}${text}`;
}
